module.exports = __webpack_public_path__ + "img/blog-11.937b46b1.jpg";